export const flexPositions = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
};
export const dataHooks = {
    modalCloseButton: 'modal-close-button',
    navigationPrevButton: 'nav-prev',
    navigationNextButton: 'nav-next',
    navigationPrevTooltip: 'nav-prev-tooltip',
    navigationNextTooltip: 'nav-next-tooltip',
};
export const ariaDescribedBy = {
    navigationPrev: 'nav-prev-label',
    navigationNext: 'nav-next-label',
};
export const labels = {
    close: 'Close',
};
//# sourceMappingURL=constants.js.map